"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../../style/annotations/Text.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var HIGHLIGHT_PADDING = 5;
var POINTER_EVENTS_SUPPORTED = !!window.PointerEvent;
/**
 * Highlight component
 * @param {Object} props - property object
 * @returns {ReactElement} markup
 */

var Highlight = function Highlight(_ref) {
  var annotation = _ref.annotation,
      annotationId = _ref.annotationId,
      commentProposedForDelete = _ref.commentProposedForDelete,
      disableInteraction = _ref.disableInteraction,
      hoveredAnnotation = _ref.hoveredAnnotation,
      isPlacingAnnotation = _ref.isPlacingAnnotation,
      onHighlightDown = _ref.onHighlightDown,
      onHighlightHover = _ref.onHighlightHover,
      scaleFactorX = _ref.scaleFactorX,
      scaleFactorY = _ref.scaleFactorY;
  var selector = annotation.target.selector;
  var pathColor = selector.strokeColor;
  var pathOpacity = selector.opacity || 0.4;
  var boundingBox = selector.boundingBox;
  var left = boundingBox[0] * scaleFactorX - HIGHLIGHT_PADDING;
  var top = boundingBox[3] * scaleFactorY - HIGHLIGHT_PADDING;
  var width = (boundingBox[2] - boundingBox[0]) * scaleFactorX + HIGHLIGHT_PADDING * 2;
  var height = (boundingBox[1] - boundingBox[3]) * scaleFactorY + HIGHLIGHT_PADDING * 2;
  var rects = (0, _react.useMemo)(function () {
    return selector.inkList.map(function (line, lineIdx) {
      var lineLeft = Math.min.apply(Math, _toConsumableArray(line.map(function (point) {
        return point.x;
      }))) * scaleFactorX;
      var lineTop = Math.min.apply(Math, _toConsumableArray(line.map(function (point) {
        return point.y;
      }))) * scaleFactorY;
      var lineRight = Math.max.apply(Math, _toConsumableArray(line.map(function (point) {
        return point.x;
      }))) * scaleFactorX;
      var lineBottom = Math.max.apply(Math, _toConsumableArray(line.map(function (point) {
        return point.y;
      }))) * scaleFactorY;
      var lineWidth = lineRight - lineLeft;
      var lineHeight = lineBottom - lineTop;
      return /*#__PURE__*/_react.default.createElement("svg", {
        key: "id-".concat(lineIdx),
        width: lineWidth,
        height: lineHeight,
        style: {
          left: lineLeft - left,
          top: lineTop - top
        }
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: lineWidth,
        height: lineHeight,
        style: {
          fill: pathColor,
          fillOpacity: pathOpacity
        },
        rx: "4"
      }));
    });
  }, [left, pathColor, pathOpacity, scaleFactorX, scaleFactorY, selector.inkList, top]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-html2canvas-ignore": annotationId === 'annotation-placeholder' ? null : true,
    className: "".concat(_Text.default.component).concat(annotationId === 'annotation-placeholder' ? ' temp-highlight' : '').concat(hoveredAnnotation === annotationId || commentProposedForDelete && annotationId === commentProposedForDelete.id ? ' hovered-text-annotation' : '').concat(isPlacingAnnotation || disableInteraction ? ' ignore-mouse-events' : ''),
    "data-annotationid": annotationId,
    "data-annotationtype": "highlight",
    style: {
      left: "".concat(left, "px"),
      top: "".concat(top, "px"),
      height: "".concat(height, "px"),
      width: "".concat(width, "px")
    },
    onPointerDown: POINTER_EVENTS_SUPPORTED ? onHighlightDown : undefined,
    onMouseDown: POINTER_EVENTS_SUPPORTED ? undefined : onHighlightDown,
    onTouchStart: POINTER_EVENTS_SUPPORTED ? undefined : onHighlightDown,
    onMouseEnter: onHighlightHover,
    onMouseLeave: onHighlightHover
  }, rects);
};

Highlight.propTypes = {
  allAnnotations: _propTypes.default.array,
  annotation: _propTypes.default.object,
  commentProposedForDelete: _propTypes.default.object,
  disableInteraction: _propTypes.default.bool,
  hoveredAnnotation: _propTypes.default.string,
  isPlacingAnnotation: _propTypes.default.bool,
  imsData: _propTypes.default.object,
  markHovered: _propTypes.default.bool,
  compactLayout: _propTypes.default.bool,
  onHighlightDown: _propTypes.default.func,
  onHighlightHover: _propTypes.default.func,
  annotationId: _propTypes.default.string,
  scaleFactorX: _propTypes.default.number,
  scaleFactorY: _propTypes.default.number,
  showResolvedComments: _propTypes.default.bool,
  touchPressed: _propTypes.default.bool
};
var _default = Highlight;
exports.default = _default;